import { Component } from '@angular/core';

@Component({
  selector: 'about-us-mission',
  templateUrl: './mission.component.html',
  styleUrls: ['./mission.component.css'],
})
export class MissionComponent {}
